import { render } from "./ProjectOffer.vue?vue&type=template&id=1885ccd0"
import script from "./ProjectOffer.vue?vue&type=script&lang=js"
export * from "./ProjectOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__